import { FC } from "react";
import ListingFilterComponent from "../../../../../common/components/listing/filter/listing-filter.component";
import OperatorListingFilter from "../common/types/operator-listing-filter";
import OperatorListingSortKey from "../common/types/operator-listing-sort-key";
import OperatorListingFilterHelper from "./operator-listing-filters.helper";
import ListingFilterDefinition from "../../../../../common/components/listing/filter/types/listing-filter-definition";
import ListingSortDefinition from "../../../../../common/components/listing/filter/types/listing-sort-definition";

type OperatorListingFilterProps = {
  filters: OperatorListingFilter[];
  onFiltersChange: (filters: OperatorListingFilter[]) => void;
  sortKey: OperatorListingSortKey;
  onSortKeyChange: (sortKey: OperatorListingSortKey) => void;
};

const OperatorListingFilterComponent: FC<OperatorListingFilterProps> = (
  props
) => {
  const filterDefinition: ListingFilterDefinition<OperatorListingFilter> =
    OperatorListingFilterHelper().getFilterDefinition();

  const sortDefinition: ListingSortDefinition =
    OperatorListingFilterHelper().getSortDefinition();

  return (
    <ListingFilterComponent
      appliedFilters={props.filters}
      filterDefinition={filterDefinition}
      onFiltersChange={(appliedFilters) => {
        props.onFiltersChange(appliedFilters as OperatorListingFilter[]);
      }}
      appliedSortKey={props.sortKey}
      onSortKeyChange={(value) =>
        props.onSortKeyChange(value as OperatorListingSortKey)
      }
      sortDefinition={sortDefinition}
      idForTestingFilter="operator-listing-filter"
      idForTestingSort="operator-listing-sort"
    />
  );
};

export default OperatorListingFilterComponent;
